export default __webpack_public_path__ + "static/media/logo-white@2x.148c080b.png";